import Layer from './BaseLayer';
import { CircleNodeQueue } from '../NodeQueue/index';

/**
* 圆形节点
*/
class CircleModeLayer extends Layer {
  constructor(props) {
    super(props);
  }

  init() {
    // 圆的中心pointer
    this.circlePointerNode = null;
    // 圆的外圈线
    this.circleNode = null;
    // 灯位
    this.lampNodeQueue =  new CircleNodeQueue({
      render: this.render
    });

    this.stage.add(this.stateNode);
  }

  setCircleNode = (pointer, circle) => {
    this.circlePointerNode = pointer;
    this.circleNode = circle;
  }

  clearCircleNode = () => {
    this.circlePointerNode = null;
    this.circleNode = null;
  }

  hasCircleNode = () => {
    return !!this.circleNode;
  }
}

export default CircleModeLayer;